import algoliasearch from 'algoliasearch'
import instantsearch from 'instantsearch.js'
import { configure } from 'instantsearch.js/es/widgets'

const tgblAlgoliaFrontend_json = window.atob(tgblAlgoliaFrontend_e)
const tgblAlgoliaFrontend = jQuery.parseJSON(tgblAlgoliaFrontend_json)

if(!window.tangibleAlgoliaInstances) window.tangibleAlgoliaInstances = {} 

const searchClient = algoliasearch(
  window.atob(tgblAlgoliaFrontend.app_id), 
  window.atob(tgblAlgoliaFrontend.search_key)
)

const getInstance = (indexId) => {
  if(window.tangibleAlgoliaInstances[indexId]) {
    
    return window.tangibleAlgoliaInstances[indexId]
  }

  const searchInstance = instantsearch({
    indexName: indexId,
    searchClient,
    searchParameters: {
      restrictSearchableAttributes: ['post_title'],
    },
    routing: true,
  });
  
  searchInstance.addWidgets([
    configure({}),
  ])

  window.tangibleAlgoliaInstances[indexId] = searchInstance;
  return window.tangibleAlgoliaInstances[indexId]
}

const registerWidget = element => {

  element.setAttribute('data-init', "true")

  /**
   * If all the elements are registered we init the instances
   */
  const elements = document.querySelectorAll("[data-init]")

  let hasUninitialized = false
  elements.forEach(element => {
    if(element.getAttribute('data-init') === 'true') return;
    hasUninitialized = true
  })

  if(hasUninitialized === true) return

  for(const key in window.tangibleAlgoliaInstances) {
    window.tangibleAlgoliaInstances[key].start()
  }

  const event = new CustomEvent('algoliaInstanceCreated', {})
  window.dispatchEvent(event)
}

export {getInstance, registerWidget}